export default "__VITE_ASSET__BnM2vRbQ__"